import {t} from "@lingui/core/macro";
import moment from "moment";

import {doNotTranslate} from "@khan/i18n";

const formatCooldownDate = (date: Date): string => {
    const dateFormat = {
        lastDay: t`[yesterday]`,
        sameDay: doNotTranslate`[]`, // empty string, escaped for moment
        nextDay: t`[tomorrow]`,
        lastWeek: "MMM Do",
        nextWeek: "MMM Do",
        sameElse: "MMM Do",
    } as const;

    const timeFormat = "h:mm A";

    const formattedDate = moment(date).calendar(moment(), dateFormat);
    const formattedTime = moment(date).format(timeFormat);
    if (formattedDate === "") {
        return formattedTime;
    }
    return `${formattedTime} ${formattedDate}`;
};

export default formatCooldownDate;
